<template>
  <Modal
    size="small"
    :show.sync="showModal"
    :on-close="close"
  >
    <div class="text-base p-4 pt-6 text-black-800">
      {{ $t('RESOLVE_MODAL.TITLE') }}
    </div>

    <div class="modal-footer footer ml-4 mr-4">
      <custom-button
        class="text-sm font-medium"
        :bg-color="widgetColor"
        :text-color="textColor"
        :disabled="isLoading"
        @click="$emit('submit')"
      >
        <spinner v-if="isLoading" class="spinner" />
        {{ $t('RESOLVE_MODAL.SUBMIT') }}
      </custom-button>
      <custom-button
        class="text-sm font-medium"
        type="smooth"
        :bg-color="widgetColor"
        :text-color="textColor"
        :disabled="isLoading"
        @click.prevent="close"
      >
        {{ $t('RESOLVE_MODAL.CANCEL') }}
      </custom-button>
    </div>
  </Modal>
</template>
<script>
import Modal from './Modal';
import CustomButton from 'shared/components/Button';
import Spinner from 'shared/components/Spinner';

export default {
  components: {
    Modal,
    CustomButton,
    Spinner,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    widgetColor: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.footer {
  justify-content: flex-start;
  column-gap: $space-slab;
}

.spinner {
  padding: 0 $space-small;
}
</style>
